import React, { useState, useEffect } from "react";
import { Collapse } from "reactstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronDown, faChevronUp } from "@fortawesome/free-solid-svg-icons";
import { useSelector } from "react-redux";
import { List } from "immutable";
import {
  getCategoryCount,
  getSubCategoryCount,
  getCustomItemsCount,
} from "../../pages/inventory/Inventory";

export default function InventoryList(props) {
  const inventoryData = useSelector((state) => state.inventoryInfo);
  const JSX = inventoryData
    .get("inventory")
    .filter((data, index) => {
      return getCategoryCount(data) > 0 ? true : false;
    })
    .map((data, index) => {
      return (
        <CollapseItemsInfo
          mainCategory={data}
          mapIndex={index}
          showAllList={props.showAll}
        />
      );
    })
    .toArray();
  return (
    <>
      {JSX}
      <CustomItemsCollapse showAllList={props.showAll} />
    </>
  );
}

export const renderTypeAndSize = (item) => {
  const hasType = item.getIn(["meta", "hasType"]);
  const hasSize = item.getIn(["meta", "hasSize"]);
  let selectedType = [];
  let selectedSize = "";
  if (hasType === true) {
    const selectedTypeList = item
      .get("type")
      .filter((type) => (type.get("selected") === true ? true : false));
    if (List.isList(selectedTypeList)) {
      selectedTypeList.forEach((type) => {
        selectedType.push(type.get("option"));
      });
      selectedType = selectedType.join(", ");
    }
  }
  if (hasSize === true) {
    const selectedSizeList = item
      .get("size")
      .filter((size) => (size.get("selected") === true ? true : false));
    if (List.isList(selectedSizeList)) {
      selectedSize = selectedSizeList.getIn([0, "option"]);
    }
  }
  if (hasType === true && hasSize === true) {
    if (selectedType.length > 0 && selectedSize !== "") {
      return selectedType + " | " + selectedSize;
    }
    if (selectedType.length > 0) {
      return selectedType;
    }
    if (selectedSize !== "") {
      return selectedSize;
    }
  }
  if (hasType === true) {
    return selectedType;
  }
  if (hasSize === true) {
    return selectedSize;
  }
};
export function CollapseItemsInfo(props) {
  const { mainCategory, mapIndex, showAllList } = props;
  const [isOpen, setIsOpen] = useState(false);
  useEffect(() => {
    if (showAllList === true) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [showAllList, mapIndex]);

  const JSX = (
    <>
      <div className="card border-0 ">
        <div className="inventory-catergory-list-group">
          <div
            className="inventory-title mb-1 d-flex justify-content-between align-items-center"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <h3 className="m-0 p-1 text-active">
              {mainCategory.get("displayName")}
              <span className="count mx-2 btn pill badge btn-sm rounded-circle">
                {getCategoryCount(mainCategory)}
              </span>
            </h3>
            <div className="collapse-icon">
              {isOpen === true ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <FontAwesomeIcon icon={faChevronDown} />
              )}
            </div>
          </div>
          <Collapse isOpen={isOpen}>
            <div className="container p-0">
              <div className="row">
                {mainCategory
                  .get("category")
                  .filter((data) => {
                    return getSubCategoryCount(data) > 0 ? true : false;
                  })
                  .map((data, index) => {
                    const JSX = (
                      <div className="col-sm-12 col-md-6 col-lg-3 col-xl-3" key={data.get("id")}>
                        <div className="rooms-inventory-list">
                          <h3 className="title">{data.get("displayName")} </h3>
                          <div className="inventory-details">
                            {data
                              .get("items")
                              .filter((item) => {
                                return item.get("qty") > 0 ? true : false;
                              })
                              .map((item, index) => {
                                // let childItemList = item
                                //   .get("childItems")
                                //   .filter((childItem) => {
                                //     return childItem.get("qty") > 0
                                //       ? true
                                //       : false;
                                //   })
                                //   .map((childItem, index) => {
                                //     return (
                                //       <ItemsInfo
                                //         parentItem={item}
                                //         childItem={childItem}
                                //         mainCategory={mainCategory}
                                //         data={data}
                                //         isChildItem={true}
                                //       />
                                //     );
                                //   })
                                //   .toArray();
                                const JSX = (
                                  <>
                                    <ItemsInfo
                                      parentItem={item}
                                      childItem={null}
                                      mainCategory={mainCategory}
                                      data={data}
                                      isChildItem={false}
                                    />
                                    {/* {childItemList} */}
                                  </>
                                );
                                return JSX;
                              })}
                          </div>
                        </div>
                      </div>
                    );
                    return JSX;
                  })
                  .toArray()}
              </div>
            </div>
          </Collapse>
        </div>
      </div>
    </>
  );
  return JSX;
}

function ItemsInfo(props) {
  const { parentItem, childItem, isChildItem } = props;

  const item = isChildItem === false ? parentItem : childItem;
  const JSX = (
    <div className="item-info-container">
      <div className="basic-info">
        <h2 className="goToItemsCard">{item.get("displayName")}</h2>
        {/* TODO:give a tooltip if selection overflows the container dimensions */}
        <h4> {renderTypeAndSize(item)} </h4>
      </div>

      <div className="qty-and-action">
        <div className="btn-group">
          <span className="d-flex align-items-center bg-white clear-btn-white-theme mr-1 qty-count">
            {item.get("qty")}
          </span>
        </div>
      </div>
    </div>
  );
  return JSX;
}

export function CustomItemsCollapse(props) {
  const { showAllList } = props;
  const inventoryData = useSelector((state) => state.inventoryInfo);
  const customItemscount = getCustomItemsCount(inventoryData);
  const [isOpen, setIsOpen] = useState(false);
  const customItemsList = inventoryData.getIn(["customItems", "items"]);
  const units =
    inventoryData.getIn(["customItems", "units"]) === "feet" ? "Ft" : "Mts";
  let JSX = <></>;
  useEffect(() => {
    if (showAllList === true) {
      setIsOpen(true);
    } else {
      setIsOpen(false);
    }
  }, [showAllList]);
  if (customItemscount > 0) {
    JSX = (
      <>
        <div className="card inventory-catergory-list-group border-0">
          <div
            className="inventory-title mb-1 d-flex justify-content-between align-items-center"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            <h3 className="m-0 p-1 active-color text-active">
              Custom Items
              <span className="count mx-2 btn pill badge btn-sm rounded-circle">
                {getCustomItemsCount(inventoryData)}
              </span>
            </h3>
            <div className="collapse-icon">
              {isOpen === true ? (
                <FontAwesomeIcon icon={faChevronUp} />
              ) : (
                <FontAwesomeIcon icon={faChevronDown} />
              )}
            </div>
          </div>
          <Collapse isOpen={isOpen}>
            <div id="customItemsCollapse" className="container p-0">
              <div className="row">
                {customItemsList
                  .map((item, index) => {
                    return (
                      <div
                        className="col-sm-12 col-md-12 col-lg-12 col-xl-12"
                        key={item.get("id")}
                      >
                        <div className="my-1 mx-2">
                          <div className="inventory-details">
                            <div className="item-info-container">
                              <div className="basic-info">
                                <h2> {item.get("item_name")}</h2>
                              </div>
                              <div className="units-info">
                                L:{`${item.get("item_length")} ${units}`}
                              </div>
                              <div className="units-info">
                                W:{`${item.get("item_width")} ${units}`}
                              </div>
                              <div className="units-info">
                                H:{`${item.get("item_height")} ${units}`}
                              </div>
                              <div className="units-info">
                                <p>{item.get("item_description")}</p>
                              </div>
                              <div className="qty-and-action">
                                <div className="btn-group">
                                  <span className="d-flex align-items-center bg-white clear-btn-white-theme mr-1 qty-count">
                                    {item.get("item_qty")}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    );
                  })
                  .toArray()}
              </div>
            </div>
          </Collapse>
        </div>
      </>
    );
    return JSX;
  }
  return JSX;
}
